import { ToastController } from "ionic-angular";
import { Injectable } from "@angular/core";

@Injectable()
export class CustomToast {

  text: string;

  constructor(public toastCtrl: ToastController) {
    console.log('Hello CustomToast');
   // this.text = 'Hello World';
  }

  showError(msg)
  {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 1500,
      position: 'top',
      cssClass: 'toast-err',
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });
      
    toast.present();
  }

  showSuccess(msg)
  {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 2000,
      position: 'top',
      cssClass: 'toast-success',
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });
      
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/custom-toast.ts